(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/shield/assets/javascripts/shield.js') >= 0) return;  svs.modules.push('/components/lb-ui/shield/assets/javascripts/shield.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  forwardRef
} = React;
const {
  clipPaths,
  Laurels
} = svs.components.lbUi.shield;
const {
  clx,
  stringToHtml
} = svs.components.lbUtils;
const Shield = forwardRef((_ref, ref) => {
  let {
    branding,
    children,
    className,
    hasAriaHidden = undefined,
    options,
    style
  } = _ref;
  const {
    borderColor,
    color,
    fillColor,
    hasHover,
    hasLaurel,
    hasShadow,
    laurelColor,
    lightColor,
    size
  } = options || {};
  const shieldClipPathsElement = document.getElementById('shield-clip-paths');
  if (!shieldClipPathsElement) {
    const fragment = stringToHtml(clipPaths);
    document.body.appendChild(fragment);
  }
  const classes = clx('shield qa-shield', {
    ["shield-".concat(branding)]: branding,
    'shield-hover': hasHover,
    'shield-laurel': hasLaurel,
    'shield-shadow': hasShadow
  }, className);
  const styles = _objectSpread({
    '--shield-border-color': borderColor,
    '--shield-fill-color': fillColor,
    '--shield-light-color': lightColor,
    '--shield-laurel-color': laurelColor,
    '--shield-size': size >= 0 ? "".concat(size, "px") : false,
    '--text-color': color
  }, style);
  return React.createElement("div", {
    "aria-hidden": hasAriaHidden,
    className: classes,
    "data-testid": "qa-shield",
    ref: ref,
    style: styles
  }, React.createElement("div", {
    className: "shield-aspect"
  }, React.createElement("div", {
    className: "shield-graphics"
  }), React.createElement("div", {
    className: "shield-content"
  }, children), hasHover && React.createElement("div", {
    className: "shield-effect"
  }, React.createElement("div", {
    className: "shield-effect-shimmer"
  })), React.createElement(Laurels, {
    isVisible: hasLaurel
  })));
});
setGlobal('svs.components.lbUi.shield.Shield', Shield);

 })(window);